import React, { Component, Fragment } from 'react'
import { connect } from 'react-redux'

import BkFlowEditGuestField from './BkFlowEditGuestField'
import BkFlowEditGuestFieldTitle from './elements/BkFlowEditGuestFieldTitle'
import BkFlowEditAddRoomsToggleDefault from './layouts/BkFlowEditAddRoomsToggleDefault'
import BkQueryGuestAddRoomsToggleSelect from './layouts/BkFlowEditAddRoomsToggleSelect'

import _ from 'lodash'

import '../../../styles/css/components/edit/guest/bk-flow-edit-stay-guest.css'

class BkFlowEditGuestContain extends Component {

	constructor(props) {
		const { urlData } = props

		super(props)
		this.state = {
			guestCount: urlData.numRooms ? Number(urlData.numRooms) : 1,
			guestEntries: []
		}
	}

	componentDidMount() {
		const { configData } = this.props
		const hotelLabels = configData.hotel.labels[0],
					guestEntry = []

		// Construct initial guest component
		for ( let i = 0; i < this.state.guestCount; i++ ) {

			guestEntry.push (
				<div className="bk-flow-edit-guest__entry" key={ 'guest-' + i }>
					<BkFlowEditGuestFieldTitle
						hotelLabels={hotelLabels}
						guestGroup={i}
						guestGroupCount={this.state.guestCount}
						removeGuestEvent={() => this.handleRemoveGuest(i)}
					/>
					<BkFlowEditGuestField roomGroup={ i } />
				</div>
			)

			this.setState({
				guestEntries: [...this.state.guestEntries, ...guestEntry]
			})
		}

		if (process.env.REACT_APP_COMPONENT_EDIT_STAY_GUEST_TOGGLE_LAYOUT !== 'select') {
			// Increment guestCount (for new guest component key and roomGroup)
			this.setState({ guestCount: this.state.guestCount + 1 })
		}
	}


	// Trigger constructing of additional unique guest data components (based upon additional room instances)
	handleAddGuest() {
		const { configData } = this.props
		const hotelLabels = configData.hotel.labels[0]

		for ( let i = 0; i < this.state.guestCount; i++ ) {

			let guestEntry = (
				<div className="bk-flow-edit-guest__entry" key={ 'guest-' + i }>
					<BkFlowEditGuestFieldTitle
						hotelLabels={hotelLabels}
						guestGroup={i}
						guestGroupCount={this.state.guestCount}
						removeGuestEvent={() => this.handleRemoveGuest(i)}
					/>
					<BkFlowEditGuestField roomGroup={ i } />
				</div>
			)

			this.setState({
				guestEntries: [...this.state.guestEntries, guestEntry]
			})
		}

		// Increment guestCount (for new guest component key and roomGroup)
		this.setState({ guestCount: this.state.guestCount + 1 })
	}


	// Trigger Search guestEntries for specific roomIndex and un-mount component
	handleRemoveGuest(index) {

		// Copy guestEntries from state and find index
		const currentGuestEntries = [...this.state.guestEntries]
		const guestIndex = currentGuestEntries.indexOf(index)

		// Remove guestIndex
		currentGuestEntries.splice(guestIndex, 1)

		this.setState({ guestEntries: currentGuestEntries })
		this.setState({ guestCount: this.state.guestCount - 1 })
	}

	handleUpdateGuests(value) {
		const { configData } = this.props
		const hotelLabels = configData.hotel.labels[0]

		let entries = []
		let i = 0

		while (i < value) {
			let guestEntry = (
				<div
					key={ 'guest-' + i }
					className="bk-query-guest__entry"
				>
					<BkFlowEditGuestFieldTitle
						hotelLabels={hotelLabels}
						guestGroup={i}
						guestGroupCount={this.state.guestCount}
						removeGuestEvent={null}
					/>
					<BkFlowEditGuestField roomGroup={ i } />
				</div>
			)

			entries.push(guestEntry)
			i++
		}

		this.setState({
			guestEntries: entries
		})

		// Increment guestCount (for new guest component key and roomGroup)
		this.setState({ guestCount: value })
	}


	render() {
		const { configData, urlData } = this.props

		const hotelLabels = configData.hotel.labels[0]

		// Window session for query reservation config
		let flowQueryConfig = null,
				activePropertyPhone = null

		if (localStorage.flowQueryConfig) {
			flowQueryConfig = JSON.parse(localStorage.flowQueryConfig)
		} else {
			flowQueryConfig = {
				maximumRooms: 10
			}
		}

		// Find correct property reservations phone number
		if (!_.isEmpty(configData)) {
			const configProperties = configData.hotel.options.properties

			// Match activeHotelCode to config properties array
			const matchedProperty = configProperties.find(function (property) {
				return property.hotelCode === String(urlData.hotelCode)
			})

			if (
				!_.isEmpty(matchedProperty) &&
				matchedProperty.contactNumbers &&
				matchedProperty.contactNumbers.reservations
			) {
				activePropertyPhone = matchedProperty.contactNumbers.reservations
			} else if (
				!_.isEmpty(matchedProperty) &&
				matchedProperty.contactNumbers &&
				matchedProperty.contactNumbers.property
			) {
				activePropertyPhone = matchedProperty.contactNumbers.property
			}
		}

		return (
			<div className={`bk-flow-edit-guest row center-xs layout-${process.env.REACT_APP_COMPONENT_EDIT_STAY_GUEST_TOGGLE_LAYOUT}`}>
				{process.env.REACT_APP_COMPONENT_EDIT_STAY_GUEST_TOGGLE_LAYOUT === 'select' ?
					<Fragment>
						<BkQueryGuestAddRoomsToggleSelect
							currentRooms={this.state.guestCount}
							flowQueryConfig={flowQueryConfig}
							hotelLabels={hotelLabels}
							updateRoomsEvent={(value) => this.handleUpdateGuests(value)}
						/>
						<div className="bk-flow-edit-guest__rooms-entries">
							{this.state.guestEntries}
						</div>
					</Fragment>
				:
					<Fragment>
						{this.state.guestEntries}

						<BkFlowEditAddRoomsToggleDefault
							activePropertyPhone={activePropertyPhone}
							addGuestEvent={() => this.handleAddGuest()}
							flowQueryConfig={flowQueryConfig}
							guestCount={this.state.guestCount}
							hotelLabels={hotelLabels}
						/>
					</Fragment>
				}
			</div>
		)
	}
}

const mapStateToProps = state => ({
	configData: state.configData.configuration,
	urlData: state.availabilityData.urlData
})

export default connect(mapStateToProps, null)(BkFlowEditGuestContain)



// WEBPACK FOOTER //
// ./src/components/edit/guest/BkFlowEditGuestContain.js